var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 4.5C23 3.67158 22.3284 3 21.5 3H17.724C17.0921 1.20736 15.4007 0.00609375 13.5 0H10.5C8.59925 0.00609375 6.90786 1.20736 6.27599 3H2.49997C1.67155 3 0.999969 3.67158 0.999969 4.5C0.999969 5.32842 1.67155 6 2.49997 6H2.99999V18.5C2.99999 21.5376 5.46242 24 8.49997 24H15.5C18.5375 24 21 21.5376 21 18.5V6H21.5C22.3284 6 23 5.32842 23 4.5ZM18 18.5C18 19.8807 16.8807 21 15.5 21H8.49997C7.11927 21 5.99999 19.8807 5.99999 18.5V6H18V18.5Z",
    fill: "#EC4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50003 18C10.3285 18 11 17.3284 11 16.5V10.5C11 9.67158 10.3285 9 9.50003 9C8.67161 9 8.00003 9.67158 8.00003 10.5V16.5C8.00003 17.3284 8.67161 18 9.50003 18Z",
    fill: "#EC4444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18C15.3284 18 16 17.3284 16 16.5V10.5C16 9.67158 15.3284 9 14.5 9C13.6715 9 13 9.67158 13 10.5V16.5C13 17.3284 13.6715 18 14.5 18Z",
    fill: "#EC4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d5cb10a9a31ccfa8739f659fe23e9162.svg";
export { ForwardRef as ReactComponent };